export const FEATURE_FLAGS = {
    hrLpAndOverlayBIR: 'BIRsignpost1',
    nextRacesBIR: 'FF110',
    MyBetFilters: 'FF107',
    accaInsurance: 'AccaInsuranceUpsellMessage',
    IPFDisplayOrder: 'IPFDisplayOrder',
    COOptimization: 'FF112',
    DummyFlag1: 'DummyFlag1',
    DummyFlag2: 'DummyFlag2',
    isInplayDisplay: 'FF111',
    SLPFootballInplayEntryPoint: 'SLPFootballInplayEntryPoint',
    SportsbookBanners: 'SportsbookBanners',
    oddsBoost: 'oddsBoost', // oddsboostIconwithouttext feature
    BetBuilderComponentTracking: 'BetBuilderComponentTracking',
};
export const DEFAULT_FLAG_VARIATIONS: { [key: string]: string | boolean } = {
    FF201: true,
    BIRsignpost1: true,
    FF110: true,
    FF107: true,
    IPFDisplayOrder: true,
    AccaInsuranceUpsellMessage: 'accaMsgProgressSignInfo',
    FF112: 'COOptimizationVariantB',
    DummyFlag1: false,
    DummyFlag2: false,
    FF111: false,
    SLPFootballInplayEntryPoint: false,
    SportsbookBanners: 'BannersControl',
    oddsBoost: 'oddsBoost', // oddsboostIconwithouttext feature
    BetBuilderComponentTracking: 'BetBuilderComponentTrackingVariantA',
};
export const CONTEXT_KINDS = {
    anonymous_user: 'anonymoususer',
    multi: 'multi',
};
export const GA_COOKIE = '_ga';
export const FALLBACK_SERVER_KEYS =
    '{singlequoteFF101singlequote:singlequotefalsesinglequote,singlequoteFF105singlequote:singlequote&quot;accabar&quot;singlequote}';
export const VARIATIONS = {
    betslip: ['betslipBarWithCounter', 'betslipBarWithoutCounter'],
    accabar: ['accabar'],
    counter: ['accabar', 'betslipBarWithCounter'],
    true: ['true'],
    false: ['false'],
    myBetFilters: ['HideBetFilters'],
    NO_HOME_PAGE_BANNERS: 'NoHomepageBanners',
    NO_BANNERS_ALL: 'NoBannersAll',
    BANNERS_CONTROL: 'BannersControl',
};

export const NO_FEATURE_STATE = false;
